import React from 'react';

const variants = {
  primary: 'bg-[#051A24] text-white hover:bg-[#0D212C] shadow-[0_4px_14px_rgba(5,26,36,0.25),0_2px_6px_rgba(5,26,36,0.2),inset_0_1px_0_rgba(255,255,255,0.1)]',
  secondary: 'bg-white text-[#051A24] hover:bg-[#F6FCFF] shadow-[0_2px_8px_rgba(5,26,36,0.1),0_1px_3px_rgba(5,26,36,0.08)]',
  tertiary: 'bg-white text-[#051A24] hover:bg-[#F6FCFF] shadow-[0_2px_8px_rgba(5,26,36,0.1),0_1px_3px_rgba(5,26,36,0.08),inset_0_-1px_2px_rgba(5,26,36,0.05)]',
};

export const Button = ({ 
  children, 
  variant = 'primary', 
  href, 
  onClick, 
  className = '',
  ...props 
}) => {
  const baseClasses = 'px-7 py-3 rounded-full font-medium text-sm transition-colors whitespace-nowrap inline-flex items-center justify-center gap-2';
  const variantClasses = variants[variant] || variants.primary;
  const combinedClasses = `${baseClasses} ${variantClasses} ${className}`;

  if (href) {
    return (
      <a href={href} className={combinedClasses} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button onClick={onClick} className={combinedClasses} {...props}>
      {children}
    </button>
  );
};

export default Button;
